import { ICustomBinding } from '#/DefaultViewExtensionInterfaces';
import ComponentManager from '@/Management/ComponentManager';
import ColumnLayoutItemT from '@/Controls/ColumnLayoutItem';

export default class ColumnLayoutRowBinding implements ICustomBinding {

    initBinding() {
        ko.bindingHandlers.columnLayoutRow = {
            init: (node: HTMLElement, valueAccessor: () => any) => {
                let ColumnLayoutItem = ComponentManager.getControl<typeof ColumnLayoutItemT>('ColumnLayoutItem');

                let row = $(node);
                let options = valueAccessor();
                let items = options.items();

                options.parent.elements = [];

                for (let i = 0; i < items.length; i++) {
                    let columnLayoutItemViewModel = items[i];

                    if (columnLayoutItemViewModel.tuple != null) {
                        if (columnLayoutItemViewModel.tuple.factory.isSummaryViewMode && i === items.length - 1) {
                            columnLayoutItemViewModel.tuple.factory.colspan = 'Fill';
                        }

                        row.addClass('c-colspan-' + columnLayoutItemViewModel.tuple.factory.colspan.toLowerCase());

                        if (columnLayoutItemViewModel.tuple.factory.colspan === 'Two') {
                            i++;
                        }
                    }

                    let columnLayoutItem = new ColumnLayoutItem(columnLayoutItemViewModel, $('<div>').appendTo(row));
                    let itemTuple = columnLayoutItem.getTuple();

                    options.parent.elements.push(columnLayoutItem);
                }
            }
        };
    }
}